<!-- <img class="header-image" *ngIf="budget.headerDesktopUrl" [src]="budget.headerDesktopUrl" /> -->
<div class="header">
  <div class="left">
    <h3 *ngIf="budget.eventName">{{ budget.eventName }}</h3>
    <h5 class="dates" *ngIf="budget.dateString">EVENT DATES: {{ budget.dateString }}</h5>
  </div>
  <div style="flex:1"></div>
  <h5 class="right">Version {{ budget.version }} | {{ info.timestamp | date:'h:mma, EEE d MMM'}}</h5>
</div>

<div class="currency" *ngIf="currencyNamesById[budget.currency] as currency">Budget Currency: {{ currency }}</div>

<ng-container *ngFor="let revenueId of budget?.revenueIds; first as first; last as last; index as index;">
  <ng-container *ngIf="budget.sections[revenueId] as section">
    <hr/>
    <budget-section 
      [first]="first"
      [last]="last"
      [fullWidth]="true"
      [readOnly]="true"
      [section]="section"
      [budgetCurrency]="budget.currency"
      [gridData]="revenueGridDatas[section.id]"
    ></budget-section>
  </ng-container>
</ng-container>
<hr/>
<budget-totals-strip *ngIf="!!budget"
  [discount]="budget.revenueDiscount"
  [fees]="budget.revenueFees"
  [readOnly]="true"
  [subtotal]="budget.revenueSubtotal"
  [tax]="budget.revenueTax"
  [total]="budget.totalRevenue"
  [currency]="budget.currency"
></budget-totals-strip>

<div class="file-links" *ngIf="!!budget?.revenueFiles?.length">
  <div class="schedule-title">File Links</div>
  <file-handler
    [readfilesonly]="true"
    [data]="{ files: budget.revenueFiles }"
    [hideByline]="true"
  ></file-handler>
</div>


<budget-schedule *ngIf="!!budget?.revenuePaymentSchedule?.items.length"
  [schedule]="budget?.revenuePaymentSchedule" 
  [gridData]="scheduleGridData"
  [readOnly]="true"
></budget-schedule>